<script setup lang="ts">
import NotificationsView from '@/components/admin/views/NotificationsView.vue'
</script>

<template>
  <NotificationsView />
</template>
